module.exports = __webpack_public_path__ + "img/port-antonio.02966a25.jpg";